enum PageNames {
     Login = "Login",
     ResetPassword = "ResetPassword",
     Sso = "Sso",
     AuthHandler = "AuthHandler",
     EntraCallback = "EntraCallback",
     AgencyPicker = "AgencyPicker",
     SysAdminSysAdminUsers = "SysAdminSysAdminUsers",
     SysAdminWorkerUsers = "SysAdminWorkerUsers",
     SysAdminApps = "SysAdminApps",
     SysAdminAgencies = "SysAdminAgencies",
     SysAdminAgencyDetails = "SysAdminAgencyDetails",
     SysAdminTableOfContentsList = "SysAdminTableOfContentsList",
     SysAdminTableOfContents = "SysAdminTableOfContents",
     SysAdminKnowledgeBase = "SysAdminKnowledgeBase",
     SysAdminKBContent = "SysAdminKBContent",
     SysAdminMediaGallery = "SysAdminMediaGallery",
     SysAdminAgenticTasks = "SysAdminAgenticTasks",
     SysAdminMigrations = "SysAdminMigrations",
     AgencyDashboard = "AgencyDashboard",
     AgencySchedule = "AgencySchedule",
     AgencyCompanies = "AgencyCompanies",
     AgencyCompanyDetails = "AgencyCompanyDetails",
     AgencyContacts = "AgencyContacts",
     AgencyContactDetails = "AgencyContactDetails",
     AgencyActivities = "AgencyActivities",
     AgencyActivityDetails = "AgencyActivityDetails",
     AgencyWorkers = "AgencyWorkers",
     AgencyWorkerWizard = "AgencyWorkerWizard",
     AgencyWorkerDetails = "AgencyWorkerDetails",
     AgencyJobs = "AgencyJobs",
     AgencyJobDetails = "AgencyJobDetails",
     AgencyOpportunities = "AgencyOpportunities",
     AgencyOpportunityDetails = "AgencyOpportunityDetails",
     AgencyOpportunityNew = "AgencyOpportunityNew",
     AgencyPayrollRuns = "AgencyPayrollRuns",
     AgencyPayrollRunDetails = "AgencyPayrollRunDetails",
     AgencyInactivityReports = "AgencyInactivityReports",
     AgencyBookings = "AgencyBookings",
     AgencyBookingWizard = "AgencyBookingWizard",
     AgencyBookingDetails = "AgencyBookingDetails",
     AgencyInvoices = "AgencyInvoices",
     AgencyInvoiceDetails = "AgencyInvoiceDetails",
     AgencyCampaigns = "AgencyCampaigns",
     AgencyCampaignDetails = "AgencyCampaignDetails",
     AgencySpecOuts = "AgencySpecOuts",
     AgencySpecOutDetails = "AgencySpecOutDetails",
     AgencyCompliance = "AgencyCompliance",
     AgencyReports = "AgencyReports",
     AgencyIndex = "AgencyIndex",
     AgencyKnowledgeBase = "AgencyKnowledgeBase",
     AgencyKBArticle = "AgencyKBArticle",
     AgencyCVParserTest = "AgencyCVParserTest",
     AgencyUserProfile = "AgencyUserProfile",
     AgencyLocations = "AgencyLocations",
     AgencyLocationDetails = "AgencyLocationDetails",
     AgencyTimesheets = "AgencyTimesheets",
     AgencyMessaging = "AgencyMessaging",
     AgencySettings = "AgencySettings",
     AgencyProfileSettings = "AgencyProfileSettings",
     AgencyAppSettings = "AgencyAppSettings",
     AgencyUserSettings = "AgencyUserSettings",
     AgencyUserDetails = "AgencyUserDetails",
     AgencyGroupSettings = "AgencyGroupSettings",
     AgencyBranchSettings = "AgencyBranchSettings",
     AgencyIntegrationSettings = "AgencyIntegrationSettings",
     AgencyIntegrationDetails = "AgencyIntegrationDetails",
     AgencyXeroAuthCallback = "AgencyXeroAuthCallback",
     AgencyMailboxCallback = "AgencyMailboxCallback",
     AgencyBusinessHoursSettings = "AgencyBusinessHoursSettings",
     AgencyEmailTemplateSettings = "AgencyEmailTemplateSettings",
     AgencyNoteCategorySettings = "AgencyNoteCategorySettings",
     AgencyActivityCategorySettings = "AgencyActivityCategorySettings",
     AgencyFaqSettings = "AgencyFaqSettings",
     AgencyConversationTopicSettings = "AgencyConversationTopicSettings",
     AgencyRateCardSettings = "AgencyRateCardSettings",
     AgencyLocationTypeSettings = "AgencyLocationTypeSettings",
     AgencyOpportunitySourceSettings = "AgencyOpportunitySourceSettings",
     AgencyOpportunityLostReasonSettings = "AgencyOpportunityLostReasonSettings",
     AgencyIndustrySettings = "AgencyIndustrySettings",
     AgencyUniformSettings = "AgencyUniformSettings",
     AgencySkillSettings = "AgencySkillSettings",
     AgencyQualificationSettings = "AgencyQualificationSettings",
     AgencyPositionSettings = "AgencyPositionSettings",
     AgencyRoleSettings = "AgencyRoleSettings",
     AgencyReportingPeriodSettings = "AgencyReportingPeriodSettings",
     AgencyKpiSettings = "AgencyKpiSettings",

     // CompanyBookings = "CompanyBookings",
     // CompanyNewBooking = "CompanyNewBooking",
     // CompanyBookingDetails = "CompanyBookingDetails",
     // CompanyLocations = "CompanyLocations",
     // CompanyLocationDetails = "CompanyLocationDetails",
     // CompanyTimesheets = "CompanyTimesheets",
     // CompanyReports = "CompanyReports",
     // CompanySettings = "CompanySettings",
     // CompanyUserProfile = "CompanyUserProfile",
     WorkerBookingOfferOld = "WorkerBookingOfferOld",
     WorkerBookingConfirmOld = "WorkerBookingConfirmOld",
     WorkerBookingOffer = "WorkerBookingOffer",
     WorkerBookingConfirm = "WorkerBookingConfirm",
     WorkerJobInvite = "WorkerJobInvite",
     WorkerInterviewConfirm = "WorkerInterviewConfirm",
     WorkerOfferAccept = "WorkerOfferAccept",
     WorkerMarketingOptOut = "WorkerMarketingOptOut",
     WorkerError = "WorkerError",
     //Backwards compatibility for candidate
     CandidateBookingOfferOld = "CandidateBookingOfferOld",
     CandidateBookingConfirmOld = "CandidateBookingConfirmOld",
     CandidateBookingOffer = "CandidateBookingOffer",
     CandidateBookingConfirm = "CandidateBookingConfirm",
     CandidateJobInvite = "CandidateJobInvite",
     CandidateInterviewConfirm = "CandidateInterviewConfirm",
     CandidateOfferAccept = "CandidateOfferAccept",
     CandidateMarketingOptOut = "CandidateMarketingOptOut",
     CandidateError = "CandidateError",
     ContactInterviewConfirm = "ContactInterviewConfirm",
     ContactOfferConfirm = "ContactOfferConfirm",
     ContactMarketingOptOut = "ContactMarketingOptOut",
     ContactError = "ContactError",
     OpportunityMarketingOptOut = "OpportunityMarketingOptOut",
}

export default PageNames;
